export default 'DUCKS/INTERLINK';
